import Vue from 'vue';
import vueC3 from 'vue-c3';

Vue.component('vue-c3', vueC3);
